import { motion } from "framer-motion";

import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";

import {
  Award,
  FileCheck2,
  GraduationCap,
  Building2,
  ArrowUpRight,
  CalendarDays,
  AlertCircle,
} from "lucide-react";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Accordion from "../../components/Accordion";
import ImageGallery from "../../components/ImageGallery";
import Modal from "../../components/Modal";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/10d66898-28e4-46f3-98fe-9d6a6e909471" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_gallery2.field_media_image,field_gallery3.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_gallery1,field_gallery2,field_gallery3,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

function SegundaLengua() {
  const processContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://portales.utpl.edu.ec/beportales/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };

  const anchorOptions = [
    {
      id: "examen",
      title: "Rendir un examen de ubicación",

      href: "#examen",
      icon: FileCheck2,
      accent:
        "hover:border-blue-500 hover:shadow-blue-500/10 text-blue-600 bg-blue-50",
    },
    {
      id: "certificados",
      title: "Reconocer certificados de otras instituciones",

      href: "#certificados",
      icon: Award,
      accent:
        "hover:border-indigo-500 hover:shadow-indigo-500/10 text-indigo-600 bg-indigo-50",
    },
    {
      id: "titulo",
      title: "Homologar títulos de tercer y cuarto nivel",

      href: "#titulo",
      icon: GraduationCap,
      accent:
        "hover:border-emerald-500 hover:shadow-emerald-500/10 text-emerald-600 bg-emerald-50",
    },
    {
      id: "instituciones",
      title: "Prepararte en instituciones externas aliadas a la UTPL",
      href: "#instituciones",
      icon: Building2,
      accent:
        "hover:border-amber-500 hover:shadow-amber-500/10 text-amber-600 bg-amber-50",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: data.texto_portada,
              }}
            />
          </>
        }
      ></BlockImageCabecera>

      <section className="py-12 bg-slate-50">
        <div className=" px-6 sm:px-0  max-w-6xl mx-auto">
          {/* Título de la sección */}

          <div className="text-center">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200">
              Grado
            </span>
          </div>

          <div className="mb-10 text-center max-w-3xl mx-auto">
            <h2>
              Para demostrar la suficiencia en una segunda lengua, debes
              considerar <b> una de las siguientes opciones:</b>
            </h2>
          </div>

          {/* Grid de opciones / anchors */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
          >
            {anchorOptions.map((option) => {
              const Icon = option.icon;
              return (
                <motion.a
                  key={option.id}
                  href={option.href}
                  variants={cardVariants}
                  whileHover={{ y: -4 }}
                  whileTap={{ scale: 0.98 }}
                  className={`group flex flex-col justify-between p-6 bg-white rounded-2xl border border-slate-200 shadow-sm transition-all duration-300 ${option.accent}`}
                >
                  <div>
                    {/* Cabecera de la tarjeta: Ícono y flecha de enlace */}
                    <div className="flex items-center justify-between mb-4">
                      <div
                        className={`p-3 rounded-xl transition-colors ${option.accent}`}
                      >
                        <Icon className="w-6 h-6" />
                      </div>
                      <div className="p-1.5 rounded-full text-slate-400 group-hover:text-slate-700 group-hover:bg-slate-100 transition-all">
                        <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                      </div>
                    </div>

                    {/* Texto */}
                    <h3 className="text-base font-semibold   ">
                      {option.title}
                    </h3>
                  </div>
                </motion.a>
              );
            })}
          </motion.div>
        </div>
      </section>

      <section id="examen" className="py-24 px-6 sm:px-0  max-w-6xl mx-auto">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-6"
        >
          <motion.div variants={cardVariants} className="lg:col-span-7   ">
            <div
              className="mb-10"
              dangerouslySetInnerHTML={{
                __html: data?.bloque1 || "",
              }}
            />
            <div className="mt-10">
              <Modal
                title="Proceso de inscripción"
                content={
                  <>
                    <div className="w-[400px] m-auto">
                      <ImageGallery gallery={data.galeria}></ImageGallery>
                    </div>
                  </>
                }
              ></Modal>
            </div>
            <div className="mt-10">
              <Modal
                title="Proceso de registro"
                content={
                  <>
                    <div className="w-[400px] m-auto">
                      <ImageGallery gallery={data.galeria1}></ImageGallery>
                    </div>
                  </>
                }
              ></Modal>
            </div>
          </motion.div>

          <motion.div
            variants={cardVariants}
            className="lg:col-span-5 bg-slate-50 rounded-2xl p-6 sm:p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow flex flex-col"
          >
            <div className="flex items-center ">
              <div className="p-2.5 bg-gray-100 text-[#004270] rounded-xl">
                <CalendarDays className="w-5 h-5" />
              </div>
            </div>

            <div
              className="button-a"
              dangerouslySetInnerHTML={{
                __html: data?.bloque2 || "",
              }}
            />
          </motion.div>

          <motion.div
            variants={cardVariants}
            className="lg:col-span-12 bg-amber-50/60 rounded-2xl p-6 sm:p-7 border border-amber-200/70 relative overflow-hidden"
          >
            <div className="  flex items-center">
              <div className="p-2 bg-gray-100 text-[#004270] rounded-lg shrink-0 mt-0.5">
                <AlertCircle className="w-5 h-5" />
              </div>
            </div>
            <div
              className="button-a"
              dangerouslySetInnerHTML={{
                __html: data?.bloque3 || "",
              }}
            />
          </motion.div>
        </motion.div>
      </section>

      <section id="certificados" className="bg-slate-50 py-24">
        <div className="max-w-6xl m-auto px-6 sm:px-0">
          <div
            className="button-a"
            dangerouslySetInnerHTML={{
              __html: data.bloque4,
            }}
          />

          <div className="my-10">
            <Modal
              title="Proceso de homologación"
              content={
                <>
                  <div className="w-[400px] m-auto">
                    <ImageGallery gallery={data.galeria2}></ImageGallery>
                  </div>
                </>
              }
            ></Modal>
          </div>

          <Accordion
            title="Certificados de Lenguas Ancestrales y Lenguas de Señas"
            content={
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque5,
                  }}
                />
              </>
            }
          ></Accordion>
          <Accordion
            title="Certificados nacionales e internacionales"
            content={
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque6,
                  }}
                />
              </>
            }
          ></Accordion>
          <Accordion
            title="Certificados de instituciones de educación superior"
            content={
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque7,
                  }}
                />
              </>
            }
          ></Accordion>
        </div>
      </section>

      <section id="titulo" className="py-24">
        <div className="max-w-6xl m-auto px-6 sm:px-0">
          <div
            className="button-a"
            dangerouslySetInnerHTML={{
              __html: data.bloque8,
            }}
          />

          <div className="my-10">
            <Modal
              title="Proceso de homologación"
              content={
                <>
                  <div className="w-[400px] m-auto">
                    <ImageGallery gallery={data.galeria3}></ImageGallery>
                  </div>
                </>
              }
            ></Modal>
          </div>
        </div>
      </section>

      <section id="instituciones" className="bg-slate-50  py-24">
        <div className="max-w-4xl m-auto px-6 sm:px-0">
          <div
            className="link-with-arrow-1 text-center"
            dangerouslySetInnerHTML={{
              __html: data.bloque9,
            }}
          />

          <div className="my-10">
            <Modal
              title="Proceso de registro"
              content={
                <>
                  <div className="w-[400px] m-auto">
                    <ImageGallery gallery={data.galeria1}></ImageGallery>
                  </div>
                </>
              }
            ></Modal>{" "}
          </div>

          <div>
            <Accordion
              title="Idioma inglés"
              content={
                <>
                  <div
                    className="[&_img]:w-40  "
                    dangerouslySetInnerHTML={{
                      __html: processContent(data.bloque10),
                    }}
                  />
                </>
              }
            ></Accordion>
            <Accordion
              title="Idioma Francés"
              content={
                <>
                  <div
                    className="[&_img]:w-40  "
                    dangerouslySetInnerHTML={{
                      __html: processContent(data.bloque11),
                    }}
                  />
                </>
              }
            ></Accordion>
            <Accordion
              title="Idioma Italiano"
              content={
                <>
                  <div
                    className="[&_img]:w-40  "
                    dangerouslySetInnerHTML={{
                      __html: processContent(data.bloque12),
                    }}
                  />
                </>
              }
            ></Accordion>
            <Accordion
              title="Idioma Portugués"
              content={
                <>
                  <div
                    className="[&_img]:w-40  "
                    dangerouslySetInnerHTML={{
                      __html: processContent(data.bloque13),
                    }}
                  />
                </>
              }
            ></Accordion>
            <Accordion
              title="Idioma Alemán"
              content={
                <>
                  <div
                    className="[&_img]:w-40  "
                    dangerouslySetInnerHTML={{
                      __html: processContent(data.bloque14),
                    }}
                  />
                </>
              }
            ></Accordion>
          </div>
        </div>
      </section>

      <section className="py-12  ">
        <div className=" px-6 sm:px-0  max-w-6xl mx-auto">
          {/* Título de la sección */}

          <div className="text-center">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200">
              Posgrado
            </span>
          </div>

          <div
            className="[&_img]:w-40  "
            dangerouslySetInnerHTML={{
              __html: processContent(data.bloque15),
            }}
          />
        </div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome2>
  );
}

export default SegundaLengua;
